const EMOJI: Record<string, string> = {
    rotating_light: '🚨',
    white_check_mark: '✅',
    warning: '⚠️',
    link: '🔗',
    x: '❌',
    heavy_check_mark: '✔️',
    hourglass: '⏳',
    hourglass_flowing_sand: '⏳',
    bell: '🔔',
    memo: '📝',
    page_facing_up: '📄',
    bar_chart: '📊',
    chart_with_upwards_trend: '📈',
    moneybag: '💰',
    money_with_wings: '💸',
    bank: '🏦',
    briefcase: '💼',
    scales: '⚖️',
    mag: '🔍',
    eyes: '👀',
    tada: '🎉',
    fire: '🔥',
    clock3: '🕒',
    calendar: '📅',
    email: '📧',
    phone: '📞',
    red_circle: '🔴',
    large_green_circle: '🟢',
    large_yellow_circle: '🟡',
    information_source: 'ℹ️',
    no_entry: '⛔',
    receipt: '🧾',
    package: '📦',
    busts_in_silhouette: '👥',
    bust_in_silhouette: '👤',
    office: '🏢',
    pushpin: '📌',
    point_right: '👉',
    arrow_right: '➡️',
    rocket: '🚀',
    lock: '🔒',
    clipboard: '📋',
    ear_of_rice: '🌾',
    tractor: '🚜',
    thumbsup: '👍',
    '+1': '👍',
    thumbsdown: '👎',
};

export const SLACK_EMOJI_SHORTCUTS = [
    'white_check_mark',
    'rotating_light',
    'warning',
    'link',
    'x',
    'bell',
    'memo',
    'bar_chart',
    'moneybag',
    'mag',
    'calendar',
    'tada',
];

export const emojiFor = (code: string): string => EMOJI[code] ?? `:${code}:`;

const escapeHtml = (text: string): string =>
    text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

const safeHref = (url: string): string => (/^(https?:|mailto:)/i.test(url) ? url : '#');

const inline = (text: string): string =>
    text
        .replace(/`([^`\n]+)`/g, '<code class="slack-code">$1</code>')
        .replace(/(^|[\s(>])\*([^*\n]+)\*/g, '$1<strong>$2</strong>')
        .replace(/(^|[\s(>])_([^_\n]+)_/g, '$1<em>$2</em>')
        .replace(/(^|[\s(>])~([^~\n]+)~/g, '$1<del>$2</del>')
        .replace(/:([a-z0-9_+-]+):/g, (_, code) => emojiFor(code));

export const mrkdwnToHtml = (source: string): string => {
    const links: string[] = [];
    const withPlaceholders = source.replace(/<([^<>|\s"']+)(?:\|([^<>]+))?>/g, (_, url: string, label?: string) => {
        links.push(
            `<a class="slack-link" href="${escapeHtml(safeHref(url))}" target="_blank" rel="noreferrer">${escapeHtml(label ?? url)}</a>`,
        );
        return `\uE000${links.length - 1}\uE000`;
    });
    const blocks = escapeHtml(withPlaceholders).split(/```/);
    const html = blocks
        .map((block, index) => {
            if (index % 2 === 1) return `<pre class="slack-pre">${block.replace(/^\n/, '')}</pre>`;
            return block
                .split('\n')
                .map((line) => {
                    const quote = /^&gt;\s?(.*)$/.exec(line);
                    if (quote) return `<span class="slack-quote">${inline(quote[1])}</span>`;
                    return inline(line);
                })
                .join('<br/>');
        })
        .join('');
    return html.replace(/\uE000(\d+)\uE000/g, (_, i) => links[Number(i)]);
};
